module.exports = __webpack_public_path__ + "static/media/KPMG_logo.svg.9465507c.png";